var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 72,
    viewBox: "0 0 75 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#20016b",
    fillRule: "evenodd",
    d: "M11.12 4.607C8.413 10.666 5.012 16.069.723 21.205c-1.405 1.681 1.33 4.24 2.86 2.624.115-.123.219-.25.334-.372l.018-.02c3.23-3.477 5.891-7.162 8.032-11.187 2.417 32.146 30.918 53.927 61.835 59.139 1.237.207 1.362-1.676.179-1.926C43.897 63.108 15.656 40.39 15.687 7.81l13.57 15.216c1.684 1.89 4.57-.56 2.982-2.548L17.444 1.96c-.647-.81-1.51-.866-2.207-.52-.96-.975-2.802-.774-3.251.649-.27.855-.562 1.693-.867 2.519z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.90c6c6e6424fc49b84b4d298998ebd4a.svg";
export { ForwardRef as ReactComponent };